import React, { useEffect, useState } from "react";
import Select from "react-select";

export type Option = {
  value: string;
  label: string;
};

export interface SelectProps {
  options: Option[];
  defaultValue?: Option;
  value?: Option; 
  className?: string;
  styles?: any;
  name?: string;
  onChange?: (option: Option | null, name?: string) => void;
  placeholder?:string;
  isDisabled?: boolean;
}

const CommonSelect: React.FC<SelectProps> = ({
  options,
  defaultValue,
  value,
  className,
  name,
  onChange,
  placeholder,
  isDisabled=false,
}) => {
  const [selectedOption, setSelectedOption] = useState<Option | undefined>(defaultValue);

  useEffect(() => {
    setSelectedOption(defaultValue || undefined);
  }, [defaultValue]);

  const currentValue = value !== undefined ? value : selectedOption;

  const handleChange = (option: Option | null) => {
    setSelectedOption(option || undefined);
    if (onChange) {
      onChange(option, name);
    }
  };

  return (
    <Select
      classNamePrefix="react-select"
      className={className}
      options={options}
      value={currentValue}
      onChange={handleChange}
      placeholder={placeholder}
      isDisabled={isDisabled}
    />
  );
};

export default CommonSelect;